import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import ReactGA from 'react-ga';


function AppContainer(props) {

    useEffect(() => {
        props.history.listen((location, action) => {
            ReactGA.pageview(window.location.pathname + window.location.search);
        });
    }, [])
    return (
        <div>{props.children}</div>
    )
}
export default withRouter(AppContainer);